import { useTranslation } from "react-i18next"
import PopupContainer from "src/component/popup/PopupContainer"
import "./style.css"
import SubmitBtn from "src/component/ActionBtn/SubmitBtn"
import { PatientData } from "src/types/patientData"
import { useCoveredMedicines } from "../hooks/useCoveredMonthsCalculation"
import CardRow from "src/component/CardRow/CardRow"

interface ISummaryRequestMedicines {
    selectedMedicinesSummaryList: any[]
    patientData: PatientData | null
    modalID: any
    handleCreateRequest: () => void
    medicinesHeaderPrices:
    {
        medicinePrice: number | null
        remainingAmount: number | null
        allowedMonthlyAmount: number | null
    }
    isLoadingSubmit: boolean
    prevModalID: any,
    coveredMonths?: number
}

const SummaryRequestMedicines = ({
    selectedMedicinesSummaryList,
    patientData,
    modalID,
    handleCreateRequest,
    medicinesHeaderPrices,
    isLoadingSubmit,
    prevModalID,
    coveredMonths
}: ISummaryRequestMedicines) => {
    const { t } = useTranslation()
    const calculatedMedicines = useCoveredMedicines(selectedMedicinesSummaryList, coveredMonths)

    return (
        <PopupContainer Name="summary-request-medicines" modalID={modalID} >

            <div>
                <div className="d-flex gap-5 justify-content-center my-3">

                    <div className="text-center">
                        <p>{t('current-medicine-price')}</p>
                        <span>{Number(medicinesHeaderPrices?.medicinePrice).toFixed(2)}</span>
                    </div>
                    <div className="text-center">
                        <p>{t('remaining-amount')}</p>
                        <span>{Number(medicinesHeaderPrices?.remainingAmount).toFixed(2)}</span>
                    </div>
                    <div className="text-center">
                        <p>{t('monthly-amount')}</p>
                        <span>{Number(medicinesHeaderPrices?.allowedMonthlyAmount).toFixed(2)}</span>
                    </div>
                </div>
                <div className="patient-details-summary row justify-content-center">
                    <CardRow title="patient-name" value={patientData?.name || ""} className="col-12 col-md-6" />
                    <CardRow title="national-id" value={patientData?.nationalId || ""} className="col-12 col-md-6" />
                    <CardRow title="decision-number" value={patientData?.decisionNumber || ""} className="col-12 col-md-6" />
                    <CardRow title="request-number" value={patientData?.requestNumber || ""} className="col-12 col-md-6" />
                    {coveredMonths && <CardRow title="monthsCoverdCount" value={`${coveredMonths || 1} ${t(`${coveredMonths > 1 ? "months" : "month"}`)}`} className="col-12" />}
                </div>

                <div className="medicines-card row">

                    {
                        calculatedMedicines.map((item) => (
                            <div className="col-12 medicines-summary-card">
                                {
                                    item.altMedicine?.value && !item.isDefault ? (
                                        <div className="medicine-card-summary">
                                            <p className="medicine-card-summary-title"> {t('medicine-Name')}: {item.altMedicine.label}</p>
                                            <CardRow title={"amount"} value={item.directAmount} unit={"units"} className="col-12 my-2 row-details" />
                                            <CardRow title={"amount-price"} value={Number(item.medicineAltPrice).toFixed(2)} unit={"egp"} className="col-12 my-2 row-details" />
                                            <CardRow title={"final-price"} value={Number(item.altPrice).toFixed(2)} unit={"egp"} className="col-12 my-2 row-details" />
                                            <CardRow title={"fromDonatedStock"} value={`${t(item.fromDonationsStock)}`} className="col-12 my-2 row-details" />
                                        </div>
                                    ) : (
                                        <div className="medicine-card-summary" >
                                            <p className="medicine-card-summary-title"> {t('medicine-Name')}: {item.medicineName}</p>
                                            <CardRow title={"amount"} value={`${item.amount}`} unit={"units"} className="col-12 my-2 row-details" />
                                            <CardRow title={"amount-price"} value={Number(item.unitPrice).toFixed(2)} unit={"egp"} className="col-12 my-2 row-details" />
                                            <CardRow title={"final-price"} value={Number(item.price).toFixed(2)} unit={"egp"} className="col-12 my-2 row-details" />
                                            <CardRow title={"fromDonatedStock"} value={`${t(item.fromDonationsStock)}`} className="col-12 my-2 row-details" />
                                        </div>
                                    )
                                }


                            </div>
                        ))
                    }

                </div>
                <div className='row my-3'>
                    <div className="col-sm-6">
                        <SubmitBtn label={t('submit-order')} onSubmit={() => handleCreateRequest()} loading={isLoadingSubmit} />
                    </div>
                    <div className="col-sm-6">
                        <SubmitBtn className={'change-request'} label={t('back')} onSubmit={() => prevModalID.current.click()} loading={isLoadingSubmit} />
                    </div>
                </div>
            </div>
        </PopupContainer>
    )
}

export default SummaryRequestMedicines


